import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { ShowAllinOnePageComponent } from './show-allin-one-page/show-allin-one-page.component';
import { PageViewerComponent } from './page-viewer/page-viewer.component';
import { TableOfContentComponent } from './shared-components/table-of-content/table-of-content.component';
import { RouteGaurdService } from '../../common/services/route-gaurd.service';

const pageRouteMatcher = (url: UrlSegment[]) => {
  if (
    (url.length >= 1)
    && url[0].path.match(/^[0-9]+$/gm)
  ) {
    return {
      consumed: url,
      posParams: {
        // publicationId: new UrlSegment(url[0].path, {}),
        pageId: new UrlSegment(url[0].path, {}),
        //publicationSlug: new UrlSegment(url[1].path, {}),
        //pageSlug: new UrlSegment(url[2].path, {})
      }
    };
  }
  return null;
}

const routes: Routes = [
  {
    canActivate: [RouteGaurdService],
    path: ':/tableOfContent',
    component: TableOfContentComponent,
    data: {
      title: 'Table of Content'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/showallinonepage',
    component: ShowAllinOnePageComponent,
    data: {
      title: 'Show All In One Page'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/:/showallinonepage',
    component: ShowAllinOnePageComponent,
    data: {
      title: 'Show All In One Page'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/:/:/showallinonepage',
    component: ShowAllinOnePageComponent,
    data: {
      title: 'Show All In One Page'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/:/:/:/showallinonepage',
    component: ShowAllinOnePageComponent,
    data: {
      title: 'Show All In One Page'
    }
  },
  {
    canActivate: [RouteGaurdService],
    path: ':/:/:/:/showallinonepage',
    component: ShowAllinOnePageComponent,
    data: {
      title: 'Show All In One Page'
    }
  },
  {
    canActivate: [RouteGaurdService],
    matcher: pageRouteMatcher,
    component: PageViewerComponent,
    data: {
      title: 'Content Page'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicationRoutingModule { }
